export class GetMemberDiscountsRequest {
    constructor(fromSearch: number, statusSearch: number, searchText: string, pageNum: number){
        this.fromSearch = fromSearch;
        this.statusSearch = statusSearch;
        this.searchText = searchText;
        this.pagenum = pageNum
    }
    fromSearch: number;
    statusSearch: number;
    searchText: string;
    pagenum: number
}
